import { AppointmentTypeFilter } from './appointment-type-filter'
import { ClientStatusFilter } from '../../shared-filters/client-status-filter'
import { ClientAgeFilter } from '../../shared-filters/client-age-filter'
import { ProgramAssignmentFilter } from '../../shared-filters/program-assignment-filter'

type ComponentMap = {
  [key: string]: any
}

type StringMap = {
  [key: string]: string
}

const constants = {
  operators: [
    { display: 'is', value: 'is' },
    { display: 'is not', value: 'is not' }
  ]
}

export const FilterCatalog: ComponentMap = {
  appointmentType: {
    component: AppointmentTypeFilter,
    constants
  },
  clientStatus: {
    component: ClientStatusFilter,
    constants
  },
  clientAge: {
    component: ClientAgeFilter,
    constants: {
      operators: [
        { display: 'less than', value: 'less-than' },
        { display: 'less than or equal to', value: 'less-than-equal' },
        { display: 'greater than', value: 'greater-than' },
        {
          display: 'greater than or equal to',
          value: 'greater-than-equal'
        },
        { display: 'equal to', value: 'equal' },
        { display: 'between (inclusive)', value: 'between-inclusive' }
      ]
    }
  },
  programAssignment: {
    component: ProgramAssignmentFilter,
    constants
  }
}

export const filterNames: StringMap = {
  appointmentType: 'Appointment Type',
  clientStatus: 'Client Status',
  clientAge: 'Client Age',
  programAssignment: 'Program Assignment'
}
